<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div
    class="edit-room-container"
    :class="{ 'hiddenn': user ===''}"
  >
    <div class="invis" />
    <div class="edit-container">
      <!-- <div class="calendar-container"> -->
      <!-- <vue-cal
          class="vuecal--blue-theme"
          xsmall
          :time-from="10 * 60"
          :time-step="2 * 60"
          :time="false"
          :disable-views="['day']"
          active-view="month"
          events-count-on-year-view
          :events="events"
          events-on-month-view="short"
        >
          <template #events-count="{ events }">
            <span v-if="customEventsCount(events)">
              {{ customEventsCount(events) }}
            </span>
          </template>
        </vue-cal> -->
      <!-- </div> -->
      <div class="second-container">
        <div class="header">
          <h1>{{ $t("VacationUpcomingEvents") }}</h1>

          <div class="year">
            <button
              style="background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box;"
              @click="decrementYear"
            >
              <b-icon-arrow-left />
            </button>
            <h5>{{ year }}</h5>
            <button
              style="background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box;"
              @click="incrementYear"
            >
              <b-icon-arrow-right />
            </button>
          </div>
          <!-- <button
            v-b-modal.leave-request
            class="buttonSubmit"
            type="button"
          >
            Leave Request
          </button> -->
        </div>
        <div style="    display: flex;">
          <div style="display: flex; margin-bottom: 15px;width: 100%; flex-wrap: wrap; gap: 0.4%;">
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto"
              class="vacRemaining"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("VacationRemainingD") }}:  {{ getVacationRequests.remainingDays }} / {{ getVacationRequests.remainingDays + getVacationRequests.countVacationTypeResponseDto.vacation }}
            </h5>
            <!-- <h5 class="vacRemaining">
              {{ $t("VacationRemainingD") }}:
              <span v-if="getVacationRequests">
                {{ getVacationRequests.remainingDays }}
              </span>
              <span v-if="getVacationRequests && getVacationRequests.countVacationTypeResponseDto">
                {{ getVacationRequests.countVacationTypeResponseDto.vacation }}
              </span>
              / {{ getVacationRequests.remainingDays }}
            </h5> -->

            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.specialLeave != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("AddNew10") }}: {{ getVacationRequests.countVacationTypeResponseDto.specialLeave }}
            </h5>
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.specialLeave != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("ConsumedDays") }}: {{ getVacationRequests.consumedDays }}
            </h5>

            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.appointment != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("AddNew11") }}: {{ getVacationRequests.countVacationTypeResponseDto.appointment }}
            </h5>
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.accidentLeave != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("AddNew12") }}: {{ getVacationRequests.countVacationTypeResponseDto.accidentLeave }}
            </h5>
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.vacation != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("VacationVacationSpent") }}: {{ getVacationRequests.countVacationTypeResponseDto.vacation }}
            </h5>
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.education != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("AddNew13") }}: {{ getVacationRequests.countVacationTypeResponseDto.education }}
            </h5>
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.maternity != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("AddNew14") }}: {{ getVacationRequests.countVacationTypeResponseDto.maternity }}
            </h5>
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.sickLeave != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("AddNew15") }}: {{ getVacationRequests.countVacationTypeResponseDto.sickLeave }}
            </h5>
            <h5
              v-if="getVacationRequests.countVacationTypeResponseDto && getVacationRequests.countVacationTypeResponseDto.deathCase != 0"
              style="width: 20%; font-size: 14px;"
            >
              {{ $t("AddNew46") }}: {{ getVacationRequests.countVacationTypeResponseDto.deathCase }}
            </h5>
          </div>
          <div
            style="display: flex;   justify-content: space-between;;
            align-items: center;"
          >
            <button
              style="border: 0;
              width: 48px;
              height: 37px; background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box; border-radius: 5px; margin-right: 5px; margin-bottom: 20px;"
              @click="downloadPDF"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="white"
                class="bi bi-file-earmark-pdf"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
              </svg>
            </button>
            <!-- <button
              style="    border: 0;
  width: 48px;
  height: 37px; background-color: #242F6E;border-radius: 5px;"
              @click="downloadEXCEL"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="white"
                class="bi bi-file-earmark-spreadsheet"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
              </svg>
            </button> -->
          </div>
        </div>
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th>{{ $t("VacationVacationT") }}</th>
                <th>{{ $t("VacationDateFromto") }}</th>
                <th>{{ $t("VacationDays") }}</th>
                <!-- <th>  {{ $t("Notes") }}</th> -->
                <th>{{ $t("VacationCancel") }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="getActiveVacationRequests.length > 0">
                <tr
                  v-for="vacation1 in getActiveVacationRequests"
                  :key="vacation1.vacationId"
                >
                  <td v-if="vacation1.vacationType === 'DeathCase'">
                    {{ $t("AddNew46") }}
                  </td>
                  <td v-if="vacation1.vacationType === 'Appointment'">
                    {{ $t("AddNew24") }}
                  </td>
                  <td v-if="vacation1.vacationType === 'Education'">
                    {{ $t("AddNew21") }}
                  </td>
                  <td v-if="vacation1.vacationType === 'SpecialLeave'">
                    {{ $t("AddNew22") }}
                  </td>
                  <td v-if="vacation1.vacationType === 'AccidentLeave'">
                    {{ $t("AddNew20") }}
                  </td>
                  <td v-if="vacation1.vacationType === 'Vacation'">
                    {{ $t("Vacation") }}
                  </td>
                  <td v-if="vacation1.vacationType === 'Maternity'">
                    {{ $t("AddNew23") }}
                  </td>
                  <td v-if="vacation1.vacationType === 'SickLeave'">
                    {{ $t("AddNew19") }}
                  </td>
                  <td>{{ dateModified2(vacation1.startVacation) }} - {{ dateModified2(vacation1.endVacation) }}</td>
                  <td>{{ vacation1.numberOfDays }}</td>
                  <!-- <td>
                    {{ vacation1.notes }}
                  </td> -->
                  <td v-if="vacation1.cancelled == true">
                    {{ $t("AddNew9") }}
                  </td>
                  <td
                    v-if="vacation1.cancelled == false"
                    v-b-modal.cancel-vacation-request
                    style="padding: 9px; text-align: left; cursor: pointer"
                    @click="cancelRequest(vacation1.vacationId)"
                  >
                    <p class="p-0 m-0 ml-50">
                      <b-icon-trash />
                    </p>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="4">
                    {{ $t("AddNew16") }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div
          class="second-container"
          style="margin-top:20px"
        >
          <div class="header">
            <h1>{{ $t("AddNew10") }}</h1>
          </div>
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>{{ $t("VacationVacationT") }}</th>
                  <th>{{ $t("VacationDateFromto") }}</th>
                  <th>{{ $t("VacationDays") }}</th>
                  <!-- <th>  {{ $t("Notes") }}</th> -->
                  <th>{{ $t("VacationSatus") }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="getInActiveVacationRequests.length > 0">
                  <tr
                    v-for="vacation2 in getInActiveVacationRequests"
                    :key="vacation2.vacationId"
                  >
                    <td v-if="vacation2.vacationType === 'DeathCase'">
                      {{ $t("AddNew46") }}
                    </td>
                    <td v-if="vacation2.vacationType === 'Appointment'">
                      {{ $t("AddNew24") }}
                    </td>
                    <td v-if="vacation2.vacationType === 'Education'">
                      {{ $t("AddNew21") }}
                    </td>
                    <td v-if="vacation2.vacationType === 'SpecialLeave'">
                      {{ $t("AddNew22") }}
                    </td>
                    <td v-if="vacation2.vacationType === 'AccidentLeave'">
                      {{ $t("AddNew20") }}
                    </td>
                    <td v-if="vacation2.vacationType === 'Vacation'">
                      {{ $t("Vacation") }}
                    </td>
                    <td v-if="vacation2.vacationType === 'Maternity'">
                      {{ $t("AddNew23") }}
                    </td>
                    <td v-if="vacation2.vacationType === 'SickLeave'">
                      {{ $t("AddNew19") }}
                    </td>
                    <td>{{ dateModified2(vacation2.startVacation) }} -  {{ dateModified2(vacation2.endVacation) }}</td>
                    <td>{{ vacation2.numberOfDays }}</td>
                    <!-- <td>
                      {{ vacation2.notes }}
                    </td> -->
                    <td
                      v-if="vacation2.cancelled == false"
                      style="color: #4BB543;"
                    >
                      {{ $t("AddNew17") }}
                    </td>
                    <td
                      v-if="vacation2.cancelled == true"
                      style="color: red;"
                    >
                      {{ $t("AddNew9") }}
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="4">
                      {{ $t("AddNew18") }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
    <!-- <LeaveRequestEmployeeModal
      :user="user"
      @pushFormUser="leaveRequests"
    /> -->
    <CancelVacationModal
      :user="user"
      :vacation-id="vacationId"
      @cancel="cancelVacationRequest"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import LeaveRequestEmployeeModal from '@/components/employees/modals/LeaveRequestEmployeeModal.vue';
import CancelVacationModal from '@/components/employees/modals/CancelVacationModal.vue';
// import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
// import FullCalendar from '@fullcalendar/vue'
// import dayGridPlugin from '@fullcalendar/daygrid'
import moment from 'moment'
// import axios from 'axios'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import FileSaver from 'file-saver';
// import * as XLSX from 'xlsx';


export default {
  components: {
    // LeaveRequestEmployeeModal,
    CancelVacationModal,
    // VueCal,
    // FullCalendar,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['user'],

  data() {
    return {
      vacation: '',
      vacationId: '',
      year: new Date().getFullYear(),
      events: [
        {
          start: '2018-11-19 10:35',
          end: '2018-11-19 11:30',
          title: 'Doctor appointment',
        },
        {
          start: '2018-11-19 18:30',
          end: '2018-11-19 19:15',
          title: 'Dentist appointment',
        },
        {
          start: '2018-11-20 18:30',
          end: '2018-11-20 20:30',
          title: 'Crossfit',
        },
        {
          start: '2018-11-21 11:00',
          end: '2018-11-21 13:00',
          title: 'Brunch with Jane',
        },
        {
          start: '2018-11-21 19:30',
          end: '2018-11-21 23:00',
          title: 'Swimming lesson',
          class: 'vacation',
        },
        {
          start: '2023-04-29 19:30',
          end: '2023-04-30 23:00',
          title: 'Swimming lesson',
          class: 'vacation',
        },
        {
          start: '2023-04-27 12:00',
          end: '2023-04-28 14:00',
          title: 'LUNCH',
          class: 'lunch',
          background: true,
        },
        {
          start: '2018-11-20 12:00',
          end: '2018-11-20 14:00',
          title: 'LUNCH',
          class: 'lunch',
          background: true,
        },
      ],
      // calendarOptions: {
      //   plugins: [dayGridPlugin],
      //   initialView: 'dayGridMonth',
      //   weekends: false,
      //   events: [
      //     { title: 'Sick Leave', start: new Date(), end: new Date() },
      //   ],
      // },
      type: null,
    };
  },
  computed: {
    ...mapGetters([
      'getVacationRequests',
      'getActiveVacationRequests',
      'getInActiveVacationRequests',
      'getPastAndFutureVacations',
      'getLoggedInUser',
      'getVacationRequests',
      'getLanguage',
    ]),
    // calendarOptions() {
    //   // Assume `getVacationRequests` is a getter that returns an object with a `vacationRequestDtos` property
    //   const vacationRequests = this.getPastAndFutureVacations;

    //   // Map vacation requests to events that can be displayed on the calendar
    //   const events = vacationRequests.map((request) => {
    //     return {
    //       title: request.vacationType,
    //       start: new Date(request.startVacation),
    //       end: new Date(request.endVacation),
    //     };
    //   });

    //   // Return calendar options with the events added
    //   return {
    //     plugins: [dayGridPlugin],
    //     initialView: 'dayGridMonth',
    //     weekends: true,
    //     events,
    //   };
    // },
  },
  watch: {
    year(value) {
      this.loadVacationRequests({
        employeeId: this.user.userId,
        year: value,
      });
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      'leaveRequest',
      'loadStoresByPagination',
      'cancelVacation',
      'loadVacationRequests',
    ]),


    downloadPDF() {
      // axios.get('https://vacationfashion.digitwebsite.ch/api/v1/DsLogistik/vocationRequests', {
      //   params: {
      //     employeeId: this.user.userId,
      //     year: this.year,
      //   },
      // })
      return this.loadVacationRequests({
        employeeId: this.user.userId,
        year: this.year,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          const tableContent = this.generateTableContent(this.getVacationRequests.vacationRequestDtos);

          const totalPages = this.getVacationRequests.totalPages;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body.push(...additionalTableContent.body);
            });

            const spimLogo = 'data:image/png;base64,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'
            const clientLogo = 'data:image/png;base64,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'
            const digITLogo = 'data:image/png;base64,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'


            const pdfDocument = this.generatePDF(tableContent, clientLogo, spimLogo, digITLogo);
            pdfDocument.save(`${this.user.firstName} ${this.user.lastName}_${moment().format('DD/MM/YYYY - hh-mm-s')}.pdf`);
          });
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    downloadPage() {
      // axios.get('https://vacationfashion.digitwebsite.ch/api/v1/DsLogistik/vocationRequests', {
      //   params: {
      //     employeeId: this.user.userId,
      //     year: this.year,
      //   },
      // })
      return this.loadVacationRequests({
        employeeId: this.user.userId,
        year: this.year,
      }).then(() => {
        // const data = response.data;
        // const items = data;

        return this.generateTableContent(this.getVacationRequests.vacationRequestDtos);
      })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    generateTableContent(items) {
      const headers = [`${this.$t('VacationVacationT')}`, `${this.$t('VacationDateFromto')}`, `${this.$t('VacationDays')}`, `${this.$t('Status')}`];
      const body = items.map((item) => {
        return [
          item.vacationType,
          `${this.dateModified2(item.startVacation)}-${this.dateModified2(item.endVacation)}`,
          // `${this.dateModified2(item.startVacation) - this.dateModified2(item.endVacation)}`,
          item.numberOfDays,
          item.cancelled ? `${this.$t('AddNew9')}` : `${this.$t('AddNew17')}`,
        ]
      });

      return { headers, body };
    },
    generatePDF(tableContent, clientLogo, spimLogo, digITLogo) {
      const { headers, body } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF();

      // Add the logo to the top left corner of the first page
      const iconWidthClient = 35; // Adjust the width of the icon as needed
      const iconHeightClient = 10; // Adjust the height of the icon as needed
      const iconYClient = 10; // Adjust the vertical position of the icon (top)
      const iconXClient = 15; // Adjust the horizontal position of the icon (left)

      const iconWidthSpim = 32; // Adjust the width of the icon as needed
      const iconHeightSpim = 12; // Adjust the height of the icon as needed
      const iconYSpim = 10; // Adjust the vertical position of the icon (top)
      const iconXSpim = 165; // Adjust the horizontal position of the icon (left)

      // Draw a blue background rectangle that spans the entire width of the paper
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 30; // Adjust the height as needed
      doc.setFillColor(0, 113, 174); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      // Add the logo image on top of the blue background on the top left
      doc.addImage(clientLogo, 'SVG', iconXClient, iconYClient, iconWidthClient, iconHeightClient);

      // const iconX = 15; // Adjust the horizontal position of the icon (left)
      doc.addImage(spimLogo, 'SVG', iconXSpim, iconYSpim, iconWidthSpim, iconHeightSpim);

      const staticContent = () => {
        // Draw blue background for the footer
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 15;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 35;
        doc.setFillColor(0, 113, 174); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        const url = 'www.dslogistik.ch';
        const urlX = doc.internal.pageSize.getWidth() / 13;
        const urlY = doc.internal.pageSize.getHeight() - 9;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'left' });

        // Add address
        const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
        const addressX = doc.internal.pageSize.getWidth() / 13;
        const addressY = doc.internal.pageSize.getHeight() - 4;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'left' });

        // Add address
        const digIT = 'Powered By';
        const digITX = doc.internal.pageSize.getWidth() - 40;
        const digITY = doc.internal.pageSize.getHeight() - 6;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(digIT, digITX, digITY, { align: 'right' });


        const iconWidthDigIT = 25; // Adjust the width of the icon as needed
        const iconHeightDigIT = 15; // Adjust the height of the icon as needed
        const iconXDigIT = doc.internal.pageSize.getWidth() - 40; // Adjust the horizontal position of the icon (left)
        const iconYDigIT = doc.internal.pageSize.getHeight() - 15; // Adjust the vertical position of the icon (top)

        doc.addImage(digITLogo, 'SVG', iconXDigIT, iconYDigIT, iconWidthDigIT, iconHeightDigIT);
      };

      // const currentTime = `${this.$t('PrintingDate')}: ${moment().format('DD/MM/YYYY, HH:mm:ss')}`;
      // const timeX = doc.internal.pageSize.getWidth() / (10 / 9);
      // const timeY = 10;
      // doc.setFontSize(10);
      // doc.setTextColor(255, 255, 255); // Black color
      // doc.text(currentTime, timeX, timeY, { align: 'right' });

      // // Add the title
      // const title = this.$t('Vacation');
      // const titleX = doc.internal.pageSize.getWidth() / 2;
      // const titleY = 18; // Adjust the vertical position of the title
      // doc.setFontSize(18);
      // doc.setTextColor(255, 255, 255); // Black color
      // doc.text(title, titleX, titleY, { align: 'center' });

      // // Add the Employeer
      // const employeeX = 15;
      // const employeeY = 27; // Adjust the vertical position of the author
      // const employee = `${this.user.firstName} ${this.user.lastName} `;
      // doc.setFontSize(12);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(`${this.$t('EmployeeName')}: ${employee}`, employeeX, employeeY);
      // // Add the author
      // const authorX = 15;
      // const authorY = 32; // Adjust the vertical position of the author
      // const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`;
      // doc.setFontSize(12);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(`${this.$t('Author')}: ${author}`, authorX, authorY);


      const title = this.$t('Vacation').toUpperCase();
      const titleX = doc.internal.pageSize.getWidth() / 2;
      const titleY = 20; // Adjust the vertical position of the title
      doc.setFontSize(25);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(title, titleX, titleY, { align: 'center' });

      // Add the author
      const authorX = 15;
      const authorY = 38; // Adjust the vertical position of the author
      const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`.toUpperCase();
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Author').toUpperCase()}: ${author}`, authorX, authorY);
      // Add the employee
      const employeeX = 15;
      const employeeY = 44; // Adjust the vertical position of the employee
      const employee = `${this.user.firstName} ${this.user.lastName} `.toUpperCase();
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('EmployeeName').toUpperCase()}: ${employee}`, employeeX, employeeY);


      const remainingX = 15;
      const remainingY = 51; // Adjust the vertical position of the remaining
      const remaining = `${this.getVacationRequests.remainingDays}`.toUpperCase();
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('VacationRemainingD').toUpperCase()}: ${remaining}`, remainingX, remainingY);


      const yearX = 15;
      const yearY = 56; // Adjust the vertical position of the year
      const year = `${this.year}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Year').toUpperCase()}: ${year}`, yearX, yearY);
      // const employee = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`.toUpperCase();
      // doc.setFontSize(12);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(`${this.$t('Employee').toUpperCase()}: ${employee}`, employeeX, employeeY);

      const printingX = doc.internal.pageSize.getWidth() - 45;
      const printingY = 37; // Adjust the vertical position of the printing
      const printing = 'PRINTING DATE:';
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${printing}`, printingX, printingY);

      const dateX = doc.internal.pageSize.getWidth() - 45;
      const dateY = 42; // Adjust the vertical position of the date
      const date = `${moment().format('MMM D, YYYY')}`;
      doc.setFontSize(13);
      doc.setTextColor(85, 185, 74)// Black color
      doc.text(`${date.toUpperCase()}`, dateX, dateY);

      const timeX = doc.internal.pageSize.getWidth() - 45;
      const timeY = 47; // Adjust the vertical position of the time
      const time = `TIME: ${moment().format('HH:mm:ss')}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${time}`, timeX, timeY);


      // Add the table
      const tableOptions = {
        startY: authorY + 20, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [0, 113, 174], // Set the background color for the header
          textColor: [255, 255, 255], // Set the text color for the header
        },
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);
      // const hrLineY = doc.internal.pageSize.getHeight() - 20;
      // const hrLineX1 = 50;
      // const hrLineX2 = doc.internal.pageSize.getWidth() - 50;
      // doc.setLineWidth(0.5); // Adjust the line thickness as needed
      // doc.line(hrLineX1, hrLineY, hrLineX2, hrLineY);

      // const iconWidthh = 30; // Adjust the width of the icon as needed
      // const iconHeightt = 10; // Adjust the height of the icon as needed
      // // const iconX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // // const iconY = doc.internal.pageSize.getHeight() - 35; // Adjust the vertical position of the icon
      // const iconXX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // const iconYY = doc.internal.pageSize.getHeight() - 18; // Adjust the vertical position of the icon

      // doc.addImage(footerIcon, 'PNG', iconXX, iconYY, iconWidthh, iconHeightt);

      // // const companyName = 'Ds-Logistik GmbH';
      // // const footerX = doc.internal.pageSize.getWidth() / 2;
      // // const footerY = doc.internal.pageSize.getHeight() - 10;
      // // doc.setFontSize(10);
      // // doc.setTextColor(0, 0, 0); // Black color
      // // doc.text(companyName, footerX, footerY, { align: 'center' });

      // const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
      // const addressX = doc.internal.pageSize.getWidth() / 2;
      // const addressY = doc.internal.pageSize.getHeight() - 2;
      // doc.setFontSize(8);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(address, addressX, addressY, { align: 'center' });

      return doc;
    },



    // generateTableContent2(items) {
    //   const headers = ['Vacation Type', 'Date from-to', 'Vacation Days'];
    //   const body = items.map((item) => {
    //     return [
    //       item.vacationType,
    //       `${this.dateModified2(item.startVacation)}-${this.dateModified2(item.endVacation)}`,
    //       // `${this.dateModified2(item.startVacation) - this.dateModified2(item.endVacation)}`,
    //       item.numberOfDays,
    //     ]
    //   });


    //   return { headers, body };
    // },
    // generateExcel(tableContent) {
    //   const { headers, body } = tableContent;
    //   const sheetData = [headers, ...body];

    //   const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    //   const workbook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    //   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //   const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    //   return excelData;
    // },
    // downloadEXCEL() {
    //   axios.get('https://vacationfashion.digitwebsite.ch/api/v1/DsLogistik/vocationRequests', {
    //     params: {
    //       employeeId: this.user.userId,
    //       year: this.year,
    //     },
    //   })
    //     .then((response) => {
    //       const data = response.data;
    //       // const items = data.items;

    //       const tableContent = this.generateTableContent(data.vacationRequestDtos);

    //       const totalPages = data.totalPages;
    //       const additionalPromises = [];
    //       for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
    //         additionalPromises.push(this.downloadPage(pageNumber));
    //       }

    //       Promise.all(additionalPromises).then((additionalTableContents) => {
    //         additionalTableContents.forEach((additionalTableContent) => {
    //           tableContent.body = tableContent.body.concat(additionalTableContent.body);
    //         });

    //         const excelData = this.generateExcel(tableContent);
    //         FileSaver.saveAs(excelData, `${this.user.firstName} ${this.user.lastName}.xlsx`);
    //       });
    //     })
    //     .catch((error) => {
    //       console.error('Error downloading the data:', error);
    //     });
    // },





    cancelRequest(value) {
      this.vacationId = value
    },
    cancelVacationRequest(value) {
      this.cancelVacation(value)
        .then(() => {
          const currentYear = new Date().getFullYear();
          this.loadVacationRequests({ employeeId: this.user.userId, year: currentYear });
        })
        .catch((error) => {
          console.error(error);
        });
      // this.filteredVacationRequestsFalse();
      // this.filteredVacationRequests();
    },
    dateModified2(xdate) {
      // const originalTime = moment(xdate);
      return moment(xdate).format('DD/MM/YYYY');
    },
    onCancel() {
      this.$refs.modal.hide();
    },
    onSubmit() {
      this.$refs.modal.hide();
    },
    incrementYear() {
      this.year++;
    },
    decrementYear() {
      this.year--;
    },
  },
};
</script>

<style scoped lang="scss">

.vacRemaining{
  font-size: 14px;
  width: 18%;
}
.vacation {
  background-color: red;
}
.year {
width: 25%;
display: flex;
justify-content: space-around;
align-items: center;
  button{
  width: 25px !important;
  display: flex;
  border-radius: 5px !important;
  justify-content: center;
  align-items: center;
  }
    h5{
  border:#b4b4b4 2px solid;
  border-radius: 6px;
  background-color: whitesmoke;
  width: 40%;
  height: 36px;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
    }
}
span{
  color: black;
}
p{
  color: black;
}
table td{
  color: black;
}
h5{
  border:#e7e6e6 2px solid;
  border-radius: 6px;
  background-color: whitesmoke;
  width: 40%;
  height: 36px;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
  margin-bottom: 5px;
    }
.edit-room-container {
  font-family: "Montserrat";
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 32px;

  .invis {
    padding-top: 164px;
  }
  .edit-container {
    width: 100%;
    // display: grid;
    // grid-auto-flow: row;
    // grid-column-gap: 47px;
    // grid-row-gap: 27px;
    // grid-template-columns: repeat(2, 1fr);
    // grid-template-rows: repeat(1, 1fr);
    text-align: left;
    justify-content: center;
    padding-top: 36px;
    padding-bottom: 38.5px;
    border-top: 1px solid black;
    .first-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: gainsboro;
      .header {
        margin-bottom: 29px;
        h1 {
          font-family: "Montserrat";
          font-style: normal;
          font-weight: 500;
          font-size: 24px;
          line-height: 29px;
          color: #000000;
        }
      }
      form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 28px;
        grid-row-gap: 39px;
      }
      .form-group {
        margin-bottom: 0px;
      }
      .form-control {
        background-color: #e8e8e8 !important;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      }
      .flex-form {
        display: flex;
        flex-direction: column;
      }
      select {
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #212529;
        background-color: #e8e8e8 !important;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        -moz-appearance: none;
        border-radius: 0.375rem;
        outline: none;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      }
      .save-btn {
        background: #242f6e;
        border: none;
        border-radius: 10px;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: #ffffff;
        padding: 8px 46.08px;
        margin-top: 35px;
      }
    }
    .second-container {
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;
        h1 {
          font-family: "Montserrat";
          font-style: normal;
          font-weight: 500;
          font-size: 24px;
          line-height: 29px;
          color: #000000;
        }
        button {
          background: #0071AE;
          border: none;
          width: 195px;
          height: 36px;
          border-radius: 6px;
          font-family: "Montserrat";
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          color: #ffffff;
          padding: 8px 22px;
        }
      }
      .table-container {
        table {
          width: 100%;
          -webkit-box-shadow: 0px 0px 20px 3px rgba(240,237,240,1);
          -moz-box-shadow: 0px 0px 20px 3px rgba(240,237,240,1);
          box-shadow: 0px 0px 20px 3px rgba(240,237,240,1);
          border-radius: 5px;
          tr {
            border-bottom: 1px solid #b6b6b6;

            th {
              padding: 10px;
              background: #0071AE;
              font-family: "Montserrat";
              font-style: normal;
              font-weight: 600;
              font-size: 12px;
              line-height: 15px;
              text-align: left;
              color: black;
            }
            th:first-child {
              border-radius: 10px 0px 0px 0px;
            }
            th:last-child {
              border-radius: 0px 10px 0px 0px;
            }
            td {
              padding: 10px;
              font-family: "Montserrat";
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              text-align: left;
              color: #000000;

              button {
                padding: 6px 18px;
                border: none;
                border-radius: 5px;
                background: #5c636a;
                color: #ffffff;
                font-family: "Montserrat";
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 15px;
                text-align: left;
              }
            }
          }
          tr:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px){
  .vacRemaining{
    font-size: 14px;
    width: 45%;
  }
}

@media only screen and (max-width: 1100px) {
  .edit-room-container {
    .edit-container {
      grid-auto-flow: row;
      grid-column-gap: 88px;
      grid-row-gap: 27px;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(2, 1fr);

      .second-container {
        margin-bottom: 30px;
      }
    }
  }
}
@media only screen and (max-width: 858px) {
  .edit-room-container {
    margin-left: 0;
    margin-top: 60px;
  }
}
@media only screen and (max-width: 620px) {
}
@media only screen and (max-width: 499px) {
  .edit-room-container {
    padding: 0 16px;
    .invis {
      padding-top: 60px;
    }
    .edit-container {
      grid-row-gap: 54px;
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(1, 1fr);

      .first-container {
        form {
          grid-template-columns: none;
          grid-row-gap: 20px;
        }
      }
    }
  }
}
.hiddenn{
  display: none;
}
.calendar-container {
  border: 2px solid #ccc;
  border-radius: 5px;
  margin-top: 25px;
  overflow: hidden; /* Prevents the border from overlapping with the header */
}

/* Style the borders of the day and time cells */
.fc-day-header, .fc-day {
  border: 1px solid #ccc;
}

/* Style the borders of the event blocks */
.fc-event-container .fc-event, .fc-event-container .fc-bgevent {
  border: 1px solid #333;
  border-radius: 3px;
  background-color: #f0f0f0;
  color: #333;
}

</style>
